import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { meeting } from '@/models';
import { Icon } from '@/components';
interface TempoaryUnmuteProps {}

const TempoaryUnmute: React.FC<TempoaryUnmuteProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer(() => {
    const { formatMessage } = useIntl();
    if (!meeting.temporaryUnmute) return null;
    return (
      meeting.temporaryUnmute && (
        <div className={s.container}>
          <Icon name="icon-on" mode="symbol" size={24} className={s.icon}></Icon>
          <span className={s.text}>{formatMessage({ id: 'temporarilyUnmute' })}</span>
        </div>
      )
    );
  })
);
export default TempoaryUnmute;
